const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Login = () => import('~/pages/auth/login-v2').then(m => m.default || m)
const Dashboard = () => import('~/pages/dashboard').then(m => m.default || m)
const CSRReport = () => import('~/pages/csr-report').then(m => m.default || m)
const CSRMembers = () => import('~/pages/csr-members').then(m => m.default || m)
const CSRMember = () => import('~/pages/csr-member').then(m => m.default || m)

const Users = () => import('~/pages/users').then(m => m.default || m)
const User = () => import('~/pages/user').then(m => m.default || m)
const Profile = () => import('~/pages/settings/profile').then(m => m.default || m)

export default [
  { path: '/', name: 'home', component: Dashboard },

  { path: '/login', name: 'login', component: Login },
  { path: '/dashboard', name: 'dashboard', component: Dashboard },
  { path: '/csr-report', name: 'csr-report', component: CSRReport },
  { path: '/csr-members', name: 'csr-members', component: CSRMembers },
  { path: '/csr-member/:id', name: 'csr-member', component: CSRMember },

  { path: '/users', name: 'users', component: Users },
  { path: '/user/:id', name: 'user', component: User },

  { path: '/profile', name: 'profile', component: Profile },
  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js